











































import { Component, Vue, Prop } from 'vue-property-decorator'
import LayoutSection from '../../components/shared/LayoutSection.vue'
import * as modules from '../../../store/decorator'

@Component({
    components: {
        layoutSection: LayoutSection
    }
})
export default class Container extends Vue {

    @Prop(Object) network!: object
    @Prop(Boolean) isDesktop!: boolean

    surveys: boolean = false

    get surveyState() {
        return this.surveys
    }

    set surveyState(newValue: boolean) {
        this.surveys = newValue
    }

    genurl(item : any) {
        return {
            name: item.path,
            /* don't remove this */
            query: {
                type: item.query
             }
        }
    }

    async mounted() {
        // Check agreement status when component mounts
        await this.checkAgreementStatus()
    }

    async checkAgreementStatus() {
        // Check if user is authenticated first
        if (!this.$auth.check()) {
            return
        }

        // Use cached agreement data from store instead of making API call
        if (!modules.user.agreementDetail.agreementAccepted) {
            this.$router.push({ name: 'agreement' })
            return
        }
    }
}
